const { produce } = require("immer");

const init = {
  uid: null,
  name: "",
  rights: [],
  apiUid: null,
  groupUid: null,
  expiration: null,
  maxProjects: null,
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_licenceForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
        if(action.form.group) draft.groupUid = action.form.group;
        if(action.form.api) draft.apiUid = action.form.api;
      });

    case "UPDATE_licenceForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "RESET_licenceForm":
      return init;

    default:
      return state;
  }
}
